import React from 'react';
import {motion} from "framer-motion";
import "./Placeholder.css";

let Placeholder = (props) => {
    return(
        <div className="Placeholder">
            <div className="Placeholder--icon">
                <motion.div animate={{y:[72,0,-10,10,0]}} transition={{delay:1.2}}>
                    {props.icon}
                </motion.div>
            </div>
            <div className="Placeholder--title">
                {props.title}
            </div>
            <div className="Placeholder--content">
                {props.children}
            </div>
        </div>
    )
}
export default Placeholder; 